export default __webpack_public_path__ + "locales/fr/FormFillingTipsDialog.json?hash=ac6e4b3a4975d18c7cfa7f0bc1c0e75b";